import styled from 'styled-components/macro';

export const InvalidRevenueCard = styled.div`
  border: 1px solid #eaeaf4;
  border-radius: 8px;
  color: ${({ theme }) => theme.olist.color.neutral.stronger};
  display: flex;
  flex-direction: row;
  gap: 8px;
  line-height: 24px;
  margin-top: 40px;
  padding: 24px;

  h3 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${({ theme }) => theme.olist.color.neutral.stronger};
  }

  strong {
    font-weight: 800;
  }

  ul {
    list-style-type: disc;
    margin-bottom: 24px;
    margin-left: 16px;
    li {
      line-height: 24px;
    }
  }
`;

export const InvalidRevenueContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
